var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.90573 4.3L0.305725 1.7C-0.0109418 1.38333 -0.0816084 1.021 0.093725 0.613C0.269058 0.205 0.581392 0.000666667 1.03073 0H6.18072C6.63072 0 6.94339 0.204333 7.11872 0.613C7.29406 1.02167 7.22306 1.384 6.90573 1.7L4.30572 4.3C4.20572 4.4 4.09739 4.475 3.98073 4.525C3.86406 4.575 3.73906 4.6 3.60573 4.6C3.47239 4.6 3.34739 4.575 3.23073 4.525C3.11406 4.475 3.00573 4.4 2.90573 4.3Z",
    fill: "#222529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.c8d716a689fd7cda937d0c199b5ba2b9.svg";
export { ForwardRef as ReactComponent };